if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.desktopMediaScrollMql = window.matchMedia('(min-width: 990px)');
      this.multiMediaWrapper = this.closest('.product__media-wrapper--multi');

      if (this.multiMediaWrapper && ['stacked', 'columns'].includes(this.dataset.desktopLayout)) {
        this.handleMediaGalleryScroll = this.updateMediaGalleryOverlay.bind(this);
        this.handleMediaGalleryResize = this.updateMediaGalleryOverlay.bind(this);
        this.addEventListener('scroll', this.handleMediaGalleryScroll, { passive: true });
        window.addEventListener('resize', this.handleMediaGalleryResize);

        if (typeof ResizeObserver !== 'undefined') {
          this.resizeObserver = new ResizeObserver(this.handleMediaGalleryResize);
          this.resizeObserver.observe(this);
        }

        window.requestAnimationFrame(() => this.updateMediaGalleryOverlay());
      }

      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      const hoverToSwitch = this.dataset.desktopLayout === 'thumbnail_slider' && window.matchMedia('(hover: hover) and (min-width: 990px)').matches;
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const button = mediaToSwitch.querySelector('button');
        button.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
        if (hoverToSwitch) {
          button.addEventListener('mouseenter', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, false));
        }
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    disconnectedCallback() {
      if (this.handleMediaGalleryScroll) {
        this.removeEventListener('scroll', this.handleMediaGalleryScroll);
      }

      if (this.handleMediaGalleryResize) {
        window.removeEventListener('resize', this.handleMediaGalleryResize);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      this.updateMediaGalleryOverlay();
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    updateMediaGalleryOverlay() {
      if (!this.multiMediaWrapper) return;

      if (!this.desktopMediaScrollMql.matches) {
        this.multiMediaWrapper.classList.remove('product__media-wrapper--overlay-hidden');
        return;
      }

      const maxScrollTop = this.scrollHeight - this.clientHeight;
      const reachedEnd = maxScrollTop <= 1 || this.scrollTop >= maxScrollTop - 2;
      this.multiMediaWrapper.classList.toggle('product__media-wrapper--overlay-hidden', reachedEnd);
    }
  });
}
